import { OnInit, } from '@angular/core';
import { FormBuilder, Validators, } from '@angular/forms';
import { ActivatedRoute, Router, } from '@angular/router';
import { AppStateFacade } from '@app-state';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@services';
import { UiSnackBarService } from '@uipath/angular/components/ui-snackbar';
import UiValidators, { UI_PASSWORD_MAX_LENGTH } from '@validators';
import { BehaviorSubject } from 'rxjs';
import { finalize, switchMap, } from 'rxjs/operators';
var PasswordChangePageComponent = /** @class */ (function () {
    function PasswordChangePageComponent(fb, auth, _route, _router, _translateService, _snack, _appState) {
        this.auth = auth;
        this._route = _route;
        this._router = _router;
        this._translateService = _translateService;
        this._snack = _snack;
        this._appState = _appState;
        this.loading$ = new BehaviorSubject(false);
        this.form = fb.group({
            'userId': [''],
            'code': [''],
            'password': ['', Validators.compose([
                    Validators.required,
                    Validators.maxLength(UI_PASSWORD_MAX_LENGTH),
                ])],
            'confirmPassword': [''],
        }, {
            validator: UiValidators.confirmPassword('password', 'confirmPassword'),
        });
    }
    PasswordChangePageComponent.prototype.ngOnInit = function () {
        var _a = [
            history.state.code,
            this._route.snapshot.queryParamMap.get('userId'),
        ], code = _a[0], userId = _a[1];
        // sanity check
        if (!code) {
            this._router.navigate(['/account/login']);
        }
        this.form.controls['userId'].setValue(userId);
        this.form.controls['code'].setValue(code);
    };
    PasswordChangePageComponent.prototype.onSubmit = function (event) {
        var _this = this;
        event.preventDefault();
        if (!this.form.valid) {
            return;
        }
        this.loading$.next(true);
        this.auth.changePassword(this.form.value)
            .pipe(switchMap(function () { return _this._appState.user.ensureCorrectIdentity(); }), finalize(function () { return _this.loading$.next(false); }))
            .subscribe(function () {
            _this._snack.success(_this._translateService.instant('password_change_success_message'));
            _this._router.navigate(['/account/login']);
        });
    };
    return PasswordChangePageComponent;
}());
export { PasswordChangePageComponent };
